'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import { SessionService } from '@/contexts/authentication';

export async function unlinkIllustrationCharacter(input: {
  bookId: string;
  extractedName: string;
}): Promise<{ success: boolean; error?: string }> {
  try {
    const familyId = await SessionService.getFamilyId();
    const userId = await SessionService.getUserId();
    if (!familyId || !userId) return { success: false, error: 'Not authenticated' };

    const { IllustrationService } = await import('@/contexts/illustrations/services/BookService');
    const { getIllustrationRepository } = await import('@/contexts/illustrations/repositories');
    const { getStoryRepository } = await import('@/contexts/stories/repositories');
    const { getCharacterRepository } = await import('@/contexts/characters/repositories');

    const service = new IllustrationService(getIllustrationRepository(), getStoryRepository(), getCharacterRepository());
    const result = await service.unlinkCharacter(input.bookId, familyId, input.extractedName);

    if (!result.success) {
      return { success: false, error: result.error || 'UNLINK_CHARACTER_FAILED' };
    }

    return { success: true };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('unlinkBookCharacter', e) };
  }
}
